import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ICourse } from "../../../Pages/Subject/ICourse";

export const EditCourseSlice = createSlice({
  name: "EditCourseSlice",
  initialState: {} as IReduxState<ICourse>,
  reducers: {
    EditCourse: (state, _: PayloadAction<ICourse>) => {
      state.isLoading = true;
    },
    successEditCourse: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureEditCourse: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearEditCourseResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  EditCourse,
  failureEditCourse,
  successEditCourse,
  clearEditCourseResponse,
} = EditCourseSlice.actions;

export default EditCourseSlice.reducer;
